<template>
  <scroll-center-dialog
    v-model="open"
    :loading="isLoadingApplications"
    @close="close"
    :applyable="false"
    :apply-text="'Записаться'"
    :left="false"
    :title="form_title"
    :scrolled="false"
  >
    <span v-if="getApplicationsResult === null && getApplicationsError === null">
      Вы уверены что хотите отменить запись?
    </span>
    <span v-else-if="getApplicationsResult !== null && getApplicationsError === null">
      <v-alert variant="outlined" type="success">
        Вы оменили запись!
      </v-alert>
    </span>
    <span v-else-if="getApplicationsResult === null && getApplicationsError !== null">
      <v-alert variant="outlined" type="error" v-for="(error, idx) in getErrors()" :key="idx">
        {{error}}
      </v-alert>
    </span>
    <template v-slot:actions>
      <v-spacer/>
      <v-btn
        v-if="getApplicationsResult === null"
        :loading="isLoadingApplications"
        class="apply__btn"
        @click="register"
      >
        <span class="apply__btn_text">
          Да
        </span>
      </v-btn>
<!--        -->
      <v-btn
        v-if="getApplicationsResult === null"
        :loading="isLoadingApplications"
        class="apply__btn"
        @click="close"
      >
        <span class="apply__btn_text">
          Нет
        </span>
      </v-btn>
     <v-btn
       v-if="getApplicationsResult !== null"
       class="apply__btn"
       @click="postSave"
      >
        <span class="apply__btn_text">
          Ок
        </span>
      </v-btn>
      <v-spacer/>
    </template>
  </scroll-center-dialog>
</template>

<script>
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog"
import { mapActions, mapGetters } from "vuex"

export default {
  name: "UserScienceIdDialog",
  props: {
    value: Boolean,
    event_id: Number,
    app_id: Number,
    application: Number,
  },
  components: {
    ScrollCenterDialog,
  },
  mixins: [FormErrorsMixin],
  data () {
    return {
      open: false,
      loading: false,
    }
  },
  watch: {
    value: {
      // immediate: true,
      handler (nV, oV) {
        this.open = this.value
      }
    },
    open: {
      // immediate: true,
      handler (nV, oV) {
        this.$emit('input', this.open)
      }
    }
  },
  computed: {
    form_title () {
      return 'science-id'
    },
    ...mapGetters({
      isLoadingApplications: 'personal_account/events/isLoadingApplications',
      getApplicationsError: 'personal_account/events/getApplicationsError',
      getApplicationsResult: 'personal_account/events/getApplicationsResult',
    }),

  },
  methods: {
    ...mapActions({
      cancelSingUpEvent: 'personal_account/events/cancelSingUpEvent',
      cleanSingUp: 'personal_account/events/cleanSingUp'
    }),
    register () {
      this.cancelSingUpEvent({
        event_id: this.event_id,
        app_id: this.app_id
      })
    },
    postSave () {
      this.cleanSingUp()
      this.$emit('save', this.getApplicationsResult)
    },
    close () {
      this.cleanSingUp()
      this.$emit('close')
    },
    getErrors () {
      const errors = []
      for (const prop in this.getApplicationsError) {
        errors.push(
          Array.isArray(this.getApplicationsError[prop])
            ? this.getApplicationsError[prop][0]
            : this.getApplicationsError[prop]
        )
      }
      return errors
    }
  },
  created () {
  }
}
</script>

<style scoped lang="scss">
.dialog__fields {
  margin-bottom: 5px;
}

.field_label__text {
  margin-bottom: 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 17px;
  display: flex;
  align-items: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;

  color: #3254B9;
}

.check__box {
  margin: 0 auto;
  width: 100%;
  color: #313743;
}

.check__box_text {
  padding-left: 30px;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  display: inline-block;
  align-items: center;
  text-align: left;
  color: #313743;
}

.apply__btn {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: end;
  margin-bottom: 40px;
  width: 136px;
  height: 40px;
  border: 2px solid #3254B9;
  background: #ffffff;
  border-radius: 5px;

  &:hover {
    background-color: #3254B9;

    .apply__btn_text {
      color: #ffffff;
    }
  }
}

.apply__btn_text {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #3254B9;
}

@media screen and (max-width: 768px) {
  .field_label__text {
    font-size: 12px;
    line-height: 15px;
  }

  .check__box_text {
    padding-left: 10px;
    font-size: 16px;
    line-height: 20px;
  }
}
</style>
